export function getDefaultSlides() {
    return {
        "title": JSON.stringify({
            template_id: "title",
            textStylesVersion: 2,
            version: 10,
            layout: {},
            states: [{
                primary: {
                    accentColor: "theme",
                    showFooter: false,
                    showPresenters: true,
                    presenters: {
                        items: [{}],
                        collectionColor: "theme"
                    },
                    text: {
                        blocks: [{
                            type: "text",
                            textStyle: "label",
                            html: ""
                        }, {
                            type: "text",
                            textStyle: "heading",
                            html: ""
                        }, {
                            type: "text",
                            textStyle: "body",
                            html: ""
                        }]
                    }
                }
            }]
        }),
        "section": JSON.stringify({
            template_id: "section",
            textStylesVersion: 2,
            version: 10,
            layout: {
                backgroundColor: "theme",
                backgroundStyle: "backgroundColor",
            },
            states: [{
                primary: {
                    fullBleed: true,
                    showGutter: true,
                    text: {
                        blocks: [{
                            type: "text",
                            textStyle: "label",
                            html: "Section 1"
                        }, {
                            type: "text",
                            textStyle: "headline",
                            html: ""
                        }]
                    }
                }
            }]
        })
    };
}
